var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.402344 0.259766H13.8869C23.0499 0.259766 26.5711 5.41468 26.5711 11.9305C26.5711 19.7247 21.6495 23.6424 13.8869 23.6424H0.402344V0.259766ZM1.68267 1.6619V22.3228H13.8868C21.2492 22.3228 25.2506 18.7762 25.2506 11.9717C25.2506 4.96104 20.9291 1.6619 13.8868 1.6619H1.68267ZM5.28395 12.3428C6.63198 12.3428 7.72477 11.2166 7.72477 9.82725C7.72477 8.43792 6.63198 7.31165 5.28395 7.31165C3.93592 7.31165 2.84313 8.43792 2.84313 9.82725C2.84313 11.2166 3.93592 12.3428 5.28395 12.3428ZM3.3234 13.4151H7.24472V20.5907H3.3234V13.4151Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.809 7.51791H21.9293V10.982H23.5699C23.1297 4.6724 18.2881 3.27026 13.8867 3.27026H9.20508V7.51791H9.88531C11.1657 7.51791 11.926 8.38393 11.926 9.82731C11.926 11.2707 11.1657 12.1367 9.92533 12.1367H9.20508V20.5908H13.8867C21.0491 20.5908 23.4899 17.1679 23.6099 12.1367H20.809V7.51791ZM15.4072 10.982V12.1367H12.6062V7.51791H15.3271V8.67261H13.7266V9.20872H15.2471V10.3634H13.7666V10.982H15.4072ZM15.8872 12.1367L17.2477 7.51791H18.8482L20.2087 12.1367H19.0483L18.8082 11.2707H17.3277L17.0876 12.1367H15.8872ZM17.6604 10.0747H17.6479V10.116L17.6604 10.0747ZM17.6604 10.0747H18.4481L18.088 8.79632H18.048L17.6604 10.0747ZM9.20508 10.982V8.67261H9.88531C10.3255 8.67261 10.8056 8.79633 10.8056 9.82731C10.8056 10.8583 10.3655 10.982 9.88531 10.982H9.20508Z",
    fill: "#D50072"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeal);
export default __webpack_public_path__ + "static/media/ideal.b0179ad5ac2da6b5c3af58ea60a399d5.svg";
export { ForwardRef as ReactComponent };